import { Frame } from "@/models/frame";

export class ImageObject extends Frame {
	name: string;
	originalWidth: number = -1;
	originalHeight: number = -1;
	readonly type: string;

	constructor(id: number) {
		super(id);
		this.name = `ImageObject${this.id}`;
		this.type = "Image";
	}

	placeNewItem(
		top: number,
		left: number,
		workspaceEl: HTMLElement,
		img: HTMLImageElement,
		width?: number,
		height?: number,
	) {
		this.originalHeight = height;
		this.originalWidth = width;

		const itemElement = super.createNewItem(top, left, width, height);

		itemElement.classList.add("eer-image-object");

		img.classList.add("eer-image-object-img");
		itemElement.appendChild(img);

		// Append the image object element to the workspace
		workspaceEl.appendChild(itemElement);

		const workspaceRect = workspaceEl.getBoundingClientRect();
		this.workspaceOverflowCheck(workspaceRect, itemElement);
		this.activeItemClear();
	}

	changeWidth() {
		const imageObjectElement = document.getElementById(`item-${this.id}`);
		imageObjectElement.style.width = `${this.width}px`;
		if (this.keepAspectRatio) {
			this.height = this.width * 0.5644;
			imageObjectElement.style.height = `${this.height}px`;
		}
	}

	changeHeight() {
		const imageObjectElement = document.getElementById(`item-${this.id}`);
		imageObjectElement.style.height = `${this.height}px`;
		if (this.keepAspectRatio) {
			this.width = this.height / 0.5644;
			imageObjectElement.style.width = `${this.width}px`;
		}
	}

	resetSize() {
		this.height = this.originalHeight;
		this.width = this.originalWidth;

		const imageObjectElement = document.getElementById(`item-${this.id}`);
		imageObjectElement.style.height = `${this.height}px`;
		imageObjectElement.style.width = `${this.width}px`;
	}

	changeImage(
		workspaceEl: HTMLElement,
		img: HTMLImageElement,
		width?: number,
		height?: number,
	) {
		const imageObjectElement = document.getElementById(`item-${this.id}`);

		while (imageObjectElement.firstChild) {
			imageObjectElement.removeChild(imageObjectElement.firstChild);
		}

		this.originalHeight = height ?? img.naturalHeight;
		this.originalWidth = width ?? img.naturalWidth;
		this.height = height ?? img.naturalHeight;
		this.width = width ?? img.naturalWidth;

		imageObjectElement.style.height = `${this.height}px`;
		imageObjectElement.style.width = `${this.width}px`;

		img.classList.add("eer-image-object-img");
		imageObjectElement.appendChild(img);

		const workspaceRect = workspaceEl.getBoundingClientRect();
		this.workspaceOverflowCheck(workspaceRect, imageObjectElement);
		this.activeItemClear();
	}
}
